var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_3231)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 0.875H0.875V13.125H5.25V0.875ZM13.125 0.875H8.75V5.25H13.125V0.875ZM13.125 8.75H8.75V13.125H13.125V8.75ZM0 0.875C0 0.642936 0.0921872 0.420376 0.256282 0.256282C0.420376 0.0921872 0.642936 0 0.875 0L5.25 0C5.48206 0 5.70462 0.0921872 5.86872 0.256282C6.03281 0.420376 6.125 0.642936 6.125 0.875V13.125C6.125 13.3571 6.03281 13.5796 5.86872 13.7437C5.70462 13.9078 5.48206 14 5.25 14H0.875C0.642936 14 0.420376 13.9078 0.256282 13.7437C0.0921872 13.5796 0 13.3571 0 13.125V0.875ZM7.875 0.875C7.875 0.642936 7.96719 0.420376 8.13128 0.256282C8.29538 0.0921872 8.51794 0 8.75 0L13.125 0C13.3571 0 13.5796 0.0921872 13.7437 0.256282C13.9078 0.420376 14 0.642936 14 0.875V5.25C14 5.48206 13.9078 5.70462 13.7437 5.86872C13.5796 6.03281 13.3571 6.125 13.125 6.125H8.75C8.51794 6.125 8.29538 6.03281 8.13128 5.86872C7.96719 5.70462 7.875 5.48206 7.875 5.25V0.875ZM8.75 7.875C8.51794 7.875 8.29538 7.96719 8.13128 8.13128C7.96719 8.29538 7.875 8.51794 7.875 8.75V13.125C7.875 13.3571 7.96719 13.5796 8.13128 13.7437C8.29538 13.9078 8.51794 14 8.75 14H13.125C13.3571 14 13.5796 13.9078 13.7437 13.7437C13.9078 13.5796 14 13.3571 14 13.125V8.75C14 8.51794 13.9078 8.29538 13.7437 8.13128C13.5796 7.96719 13.3571 7.875 13.125 7.875H8.75Z",
    fill: "#F8F9FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_3231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.3d52c27da89003599797a42d593c53ef.svg";
export { ForwardRef as ReactComponent };